"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSoundControls = exports.useSound = void 0;
var useSound_1 = require("./useSound");
Object.defineProperty(exports, "useSound", { enumerable: true, get: function () { return __importDefault(useSound_1).default; } });
var useSoundControls_1 = require("./useSoundControls");
Object.defineProperty(exports, "useSoundControls", { enumerable: true, get: function () { return __importDefault(useSoundControls_1).default; } });
